<template>
  <div>
    <h5>Arraste os veículos afim de mostrar como ocasionou o ocorrido.</h5>
    <div class="vx-row mt-2 mb-4" v-if="croquiPronto">
      <div class="vx-col">
        <img :src="enderecoCroquiPronto" />
      </div>
    </div>
    <v-stage
      v-else
      ref="stage"
      :config="stageSize"
      @mousedown="handleStageMouseDown"
      @touchstart="handleStageMouseDown"
    >
      <v-layer v-if="image"><v-image :config="imgFundo"> </v-image> </v-layer
      >
      <v-layer v-if="image" ref="layer"
        >
          <v-image
          v-for="item in cars"
          :key="item.id"
          @dragstart="handleDragStart"
          @dragend="handleDragEnd"
          @transformend="handleTransformEnd"
          :config="item"
        >
          </v-image>
          <v-transformer ref="transformer"/>
        
        </v-layer>
    </v-stage>

    <h5 class="mt-3 mb-3">Legenda</h5>
    <div class="mb-3">
      <div v-for="item in cars" :key="item.id">
        <div class="flex mb-2">
          <div>
            <img width="20" height="20" :src="item.imgAux" />
          </div>
          <div>
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <vs-row>
      <vs-col class="mt-3 mb-3 gap-6" vs-type="flex" vs-justify="flex-end">
        <vs-button
        v-if="croquiPronto"
          color="primary"
          type="filled"
          class=""
          @click="croquiPronto = false"
          >Editar Croqui</vs-button
        >
        <vs-button v-else color="success" type="filled" class="" @click="uploadCroqui"
          >Salvar Croqui</vs-button
        >
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import service from '../../../services';
import canvasToBlob from 'blueimp-canvas-to-blob';
import carroAzul from '../../../assets/images/croqui/carro-azul.png';
import carroVermelho from '../../../assets/images/croqui/carro-vermelho.png';
import carroVerde from '../../../assets/images/croqui/carro-verde.png';
import carroRoxo from '../../../assets/images/croqui/carro-roxo.png';
import motoAzul from '../../../assets/images/croqui/moto-azul.png';
import motoVerde from '../../../assets/images/croqui/moto-verde.png';
import motoAzulEscuro from '../../../assets/images/croqui/moto-azul-escuro.png';
import motoRoxa from '../../../assets/images/croqui/moto-roxa.png';
import caminhaoAzul from '../../../assets/images/croqui/caminhao-azul.png';
import caminhaoVerde from '../../../assets/images/croqui/caminhao-verde.png';
import caminhaoVermelho from '../../../assets/images/croqui/caminhao-vermelho.png';
import caminhaoRoxo from '../../../assets/images/croqui/caminhao-roxo.png';
const width = window.innerWidth;
const height = window.innerHeight;

export default {
  props: ['croqui', 'envolvidos', 'evento'],
  watch: {
    envolvidos() {
      this.carregaCroqui();
    },
    croqui(croqui) {
      if (croqui) {
        this.croquiPronto = true;
        this.enderecoCroquiPronto = croqui;
      }
    },
  },
  data() {
    const stageSize = {
      id: 'canvas-container',
      width: width,
      height: height,
    };
    const imgFundo = {
      x: 0,
      y: 0,
      image: null,
      width: width,
      height: height,
    };
    const isDragging = false;
    const image = null;
    const cars = [];
    const selectedShapeName = '';
    const files = new FormData();
    const croquiPronto = false;
    return {
      stageSize,
      imgFundo,
      isDragging,
      image,
      cars,
      selectedShapeName,
      files,
      croquiPronto,
    };
  },
  mounted() {},
  methods: {
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.cars.find((r) => r.name === this.selectedShapeName);
      // update the state
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      console.log(e);
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.cars.find((r) => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
      transformerNode.getLayer().batchDraw();
    },
    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    buscarEnvolvidos() {
      return service
        .post('Eventos', 'listaEnvolvidosPorEvento', {
          idEvento: this.$route.params.idEvento,
        })
        .then((res) => res.data)
        .catch((e) => console.log('erro', e));
    },
    async carregaCroqui() {
      let envolvidos = this.envolvidos;
      if (
        !envolvidos ||
        !Array.isArray(envolvidos) ||
        envolvidos.length === 0
      ) {
        envolvidos = await this.buscarEnvolvidos();
      }
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = `https://bboneapp.s3.amazonaws.com/imgsPadrao/imgEventos/bgrua.png`;
      image.onload = () => {
        this.image = image;
        this.imgFundo.image = image;
        var cont = {
          1: 1,
          2: 1,
          3: 1,
        };
        this.cars = [];
        envolvidos.forEach((element, index) => {
          this.cars.push({
            rotation: 0,
            x: 50 * (index + 1),
            y: 50 * (index + 1),
            scaleX: 1,
            scaleY: 1,
            name: 'car' + index + 1,
            image: null,
            draggable: true,
            text: element.nome,
            tipoVeiculo: element.codTipoVeiculo,
          });
        });
        this.cars.forEach((element) => {
          const imageaux = new Image();
          //imageaux.setAttribute("crossorigin", "anonymous");
          imageaux.crossOrigin = 'Anonymous';

          // O problema do cors estava impedidndo de carregar os icones dos veiculos, por isso foi
          // necessario traze-los para o front
          imageaux.src = this.escolheIconeVeiculo(
            element.tipoVeiculo,
            cont[element.tipoVeiculo],
          );
          // imageaux.src = `https://bboneapp.s3.amazonaws.com/imgsPadrao/imgEventos/${
          //       element.tipoVeiculo
          //     }/${cont[element.tipoVeiculo]}.png`;

          imageaux.width = 50;
          imageaux.height = 50;
          element.imgAux = imageaux.src;
          cont[element.tipoVeiculo] = cont[element.tipoVeiculo] + 1;
          imageaux.onload = () => {
            element.image = imageaux;
          };
        });
      };
    },
    escolheIconeVeiculo(tipo, count) {
      const veiculos = {
        1: {
          1: carroVerde,
          2: carroVermelho,
          3: carroAzul,
          4: carroRoxo,
        },
        2: {
          1: motoAzul,
          2: motoRoxa,
          3: motoAzulEscuro,
          4: motoVerde,
        },
        3: {
          1: caminhaoRoxo,
          2: caminhaoAzul,
          3: caminhaoVerde,
          4: caminhaoVermelho,
        },
      };
      return veiculos[tipo][count];
    },
    uploadCroqui() {
      var data = this.$refs.stage.getStage().toDataURL();
      var blob = canvasToBlob(data);
      this.files.set('file', blob, 'croqui.png');
      this.$vs.loading();
      return service
        .upload('Upload', 'Eventos/' + this.$route.params.idEvento, this.files)
        .then((res) => {
          this.$vs.loading.close();
          this.salvarCroquiTabelaEventos(res);
          this.croquiPronto = true;
          this.enderecoCroquiPronto = res;
        })
        .catch((e) => {
          this.$vs.loading.cloese();
          console.log('erro', e);
        });
    },
    salvarCroquiTabelaEventos(croqui) {
      return service.put(
        'Eventos',
        'Atualizar/' + this.$route.params.idEvento,
        { croqui, passo: 7 },
      );
    },
  },
};
</script>
<style></style>
